import { DocumentPanel } from '../components/DocumentPanel'
import type { PanelPlugin } from './types'

// Document reader as a panel contribution — opened when a chat attachment card is tapped
// (the card calls openDocument(); AppShell brings this panel on-screen). The active doc
// lives in lib/documentViewer, so the panel needs no per-open props beyond the chat. See
// PLUGIN_MODULES.md → Contribution Points (panel) + docAttach.
export const documentPanel: PanelPlugin = {
  id: 'document',
  title: 'Document',
  icon: 'file-text',
  render: ({ chatId, onClose }) => (
    <DocumentPanel key={chatId} chatId={chatId} onClose={onClose} />
  ),
}
